import { VbzButton, VbzModal } from "@smiles/voebiz-ui-kit";
import React, { FC } from "react";
import { ModalBody } from "reactstrap";

export interface WithoutReimbursementProps {
  isOpenModalReimbursement: boolean;
  toggle: () => void;
  cancelPathUrl: string;
}

const ModalWithoutReimbursement: FC<WithoutReimbursementProps> = ({
  isOpenModalReimbursement,
  toggle,
  cancelPathUrl,
}) => {
  return (
    <VbzModal isOpen={isOpenModalReimbursement} toggle={toggle} desktopSize="small">
      <ModalBody className="modal-body-no-reimbursement">
        <div className="modal-no-reimbursement__title">
          <h4>Esta viagem não possui reembolso de tarifa</h4>
        </div>

        <div className="modal-no-reimbursement__description ">
          <p>Você está prestes a cancelar uma viagem que não possui tarifas reembolsáveis.</p>
          <p>Tem certeza que deseja cancelar o seu voo?</p>
        </div>
        <div className="no-reimbursement-modal-btn">
          <VbzButton
            id="cancelFlightBtn"
            className="no-reimbursement-modal-btn"
            color="primary"
            text="Quero cancelar meu voo"
            onClick={() => {
              window.location.href = cancelPathUrl;
            }}
          />
        </div>
        <VbzButton
          id="closeBtnId"
          className="back-modal-btn"
          color="hyperlink"
          text="Voltar para Meus voos"
          onClick={toggle}
        />
      </ModalBody>
    </VbzModal>
  );
};

export default ModalWithoutReimbursement;
